import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popular-book-card',
  templateUrl: './popular-book-card.component.html',
  styleUrls: ['./popular-book-card.component.css']
})
export class PopularBookCardComponent implements OnInit {

  @Input() popularBookCardData:any;

  constructor() { }

  ngOnInit(): void {
  }

}
